import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";
import {
  FormControl,
  InputLabel,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Checkbox,
  Link,
  FormHelperText,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Container,
} from "@mui/material";
import VideoSkeleton from "./VideoSkeleton";

const LeaderboardSkeleton = () => {
  return (
    <Box className="userLayout" style={{ marginTop: "0px" }}>
      <Container
        disableGutters={true}
        maxWidth="lg"
        sx={{ background: "#242743" }}
      >
        <Box className="home-options-wrapper" style={{ position: "unset" }}>
          <Box className="home-options-inner">
            <Skeleton
              animation="wave"
              variant="rectangular"
              height={25}
              width="30%"
              sx={{
                marginTop: "20px",
              }}
            />
          </Box>
        </Box>

        <Box className="leader-board-main">
          <Box className="leader-board-wrapper">
            <Box className="month-filter-wrapper">
              <Button className="filter">
                {" "}
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{
                    width: "50%",
                    height: "20px",
                  }}
                />
              </Button>
              <Button className="filter">
                {" "}
                <Skeleton
                  animation="wave"
                  variant="body1"
                  sx={{
                    width: "50%",
                    height: "20px",
                  }}
                />
              </Button>
            </Box>
            <Box className="Category-filter-wrapper">
              <Button className="filter">
                {" "}
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{
                    width: "50%",
                    height: "20px",
                  }}
                />
              </Button>
              <Button className="filter">
                {" "}
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{
                    width: "50%",
                    height: "20px",
                  }}
                />
              </Button>
              <Button className="filter">
                {" "}
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{
                    width: "50%",
                    height: "20px",
                  }}
                />
              </Button>
              <Button className="filter">
                {" "}
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{
                    width: "50%",
                    height: "20px",
                  }}
                />
              </Button>
              <Button className="filter">
                {" "}
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{
                    width: "50%",
                    height: "20px",
                  }}
                />
              </Button>
            </Box>

            <Box className="leaderboard-data-wrapper">
              {Array.from({ length: 10 }).map((ele) => (
                <VideoSkeleton />
              ))}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default LeaderboardSkeleton;
